export class GetListFilterResponse {
  customers!: {
    name: string;
    customerIsa: string;
  }[];
  shipmentId!: string[];
  city!: string[];
  zip!: string[];
}
